<template>
    <circle :style="{ fill: color }" cx="53.8" cy="63.8" r="50"/>
</template>

<script>
    export default {
        name: 'Background1',
        props: {
            color: {
                type: String,
                required: true,
            },
        },
    }
</script>
